import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = {
  id: "headerNav",
  "class": "flex-align"
};
var _hoisted_2 = {
  "class": "title"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_cache[0] || (_cache[0] = _createElementVNode("div", {
    "class": "area"
  }, null, -1)), _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.content), 1)]);
}